import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { getTheme } from '@/styles/theme';
import { router } from '@/lib/router.tsx';
import { queryClient } from '@/lib/queryClient';
import { I18nProvider } from '@lingui/react';
import { i18n } from '@lingui/core';
import { AuthProvider } from '@/features/auth/components/auth-context/AuthProvider.tsx';
import { ErrorBoundary } from '@/common/components/error-boundary/ErrorBoundary.tsx';
import { Suspense } from 'react';
import { PageLoader } from '@/common/components/page-loader/PageLoader.tsx';

export const App = () => {
  return (
    <I18nProvider i18n={i18n}>
      <ThemeProvider theme={getTheme(i18n.locale)}>
        <ErrorBoundary sx={{ height: '100vh' }}>
          <CssBaseline />
          <Suspense fallback={<PageLoader />}>
            <QueryClientProvider client={queryClient}>
              <AuthProvider>
                <RouterProvider router={router} />
              </AuthProvider>
            </QueryClientProvider>
          </Suspense>
        </ErrorBoundary>
      </ThemeProvider>
    </I18nProvider>
  );
};
